module.exports = __webpack_public_path__ + "media/images/payments/dinersclub-a93a6747e809c43b85d01cc005f03a8f.svg";